// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"cc439fc7","618":"5754978c"}[chunkId] + ".chunk.js";
};